<div
  class="xi-modal__container"
  *transloco="let t; read: 'create-comparison-filter-dialog-component'"
>
  <h2 class="xi-modal__title">{{ t('create-comparison-filter') }}</h2>
  <form [formGroup]="comparisonFilterForm">
    <div class="xi-modal__content">
      <div class="create-comparison-filter__type-section">
        <span>{{ t('comparison-type', { type: t(options.type) | titlecase }) }}</span>
        <xi-icon icon="info" [tooltipProps]="{ text: typeTooltip, direction: 3 }"></xi-icon>
      </div>

      <div class="create-comparison-filter__dropdowns-section">
        <xi-dropdown
          placeholder="{{ t('data-placeholder') }}"
          label="{{ t('data-label') }}"
          [stretch]="true"
          [data]="dataSources"
          formControlName="dataSource"
          (click)="openDataSourceSelector($event)"
          cdkOverlayOrigin
          #dataSourceTrigger="cdkOverlayOrigin"
        ></xi-dropdown>

        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="dataSourceTrigger"
          [cdkConnectedOverlayOpen]="isDataSourceSelectorVisible"
          [cdkConnectedOverlayWidth]="444"
          [cdkConnectedOverlayHeight]="333"
          (overlayOutsideClick)="isDataSourceSelectorVisible = false"
        >
          <app-datasource-selector
            [dataSources]="options.dataSources"
            [previousDataSourceId]="selectedDataSource?.id"
            (dataSourceSelect)="onDataSourceSelected($event)"
          ></app-datasource-selector>
        </ng-template>

        <xi-dropdown
          placeholder="{{ t('field-placeholder') }}"
          label="{{ t('field-label') }}"
          [stretch]="true"
          [data]="dataSourceFields"
          formControlName="dataField"
        ></xi-dropdown>
      </div>

      <div class="create-comparison-filter__filter-section">
        <p>{{ t('define-filter') }}</p>

        @if (!isLoading) {
          <app-comparison-filter-item
            [allFilters]="options.allFilters"
            [type]="options.type"
            [subType]="subType"
            [dateType]="dateType"
            [(filtersLabel)]="filtersLabelValue"
            [(filtersColor)]="filtersColorValue"
            [(filters)]="filtersValue"
            [filtersExtraDropdown]="filtersExtraDropdown"
            (filtersRemove)="onFiltersRemoved()"
            [dataSource]="selectedDataSource"
            [field]="selectedField"
            [fieldExtra]="selectedFieldExtra"
            [projectId]="options.projectId"
            [filterLabelStatus]="filterLabelStatus"
            [isDialog]="true"
          ></app-comparison-filter-item>
        }
      </div>
    </div>

    <div class="xi-modal__actions create-comparison-filter__actions">
      <xi-default-button
        text="{{ t('cancel') }}"
        fill="text"
        (onClick)="cancel()"
      ></xi-default-button>

      <xi-default-button
        text="{{ t('create') }}"
        [disabled]="comparisonFilterForm.invalid"
        (onClick)="create()"
      ></xi-default-button>
    </div>
  </form>
</div>
